"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Bike_1 = require("./Bike");
var ClosedLegBW_1 = require("./ClosedLegBW");
var ClosedLegWB_1 = require("./ClosedLegWB");
var CrossedLegs_1 = require("./CrossedLegs");
var HandsBackBW_1 = require("./HandsBackBW");
var HandsBackWB_1 = require("./HandsBackWB");
var MediumBW_1 = require("./MediumBW");
var MediumWB_1 = require("./MediumWB");
var OneLegUpBW_1 = require("./OneLegUpBW");
var OneLegUpWB_1 = require("./OneLegUpWB");
var Wheelchair_1 = require("./Wheelchair");
exports.SittingPose = {
    Bike: Bike_1.Bike,
    ClosedLegBW: ClosedLegBW_1.ClosedLegBW,
    ClosedLegWB: ClosedLegWB_1.ClosedLegWB,
    CrossedLegs: CrossedLegs_1.CrossedLegs,
    HandsBackBW: HandsBackBW_1.HandsBackBW,
    HandsBackWB: HandsBackWB_1.HandsBackWB,
    MediumBW: MediumBW_1.MediumBW,
    MediumWB: MediumWB_1.MediumWB,
    OneLegUpBW: OneLegUpBW_1.OneLegUpBW,
    OneLegUpWB: OneLegUpWB_1.OneLegUpWB,
    WheelChair: Wheelchair_1.WheelChair
};
//# sourceMappingURL=z_options.js.map